export default "__VITE_ASSET__B_aB_FkV__"